/**
 * Typed safety-surface manifest for Invariant Lifecycle Governance.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import { parseContribDoctrineManifest } from "@csk/demo-ui";
import rawDoctrineManifest from "./doctrineManifest.json" with { type: "json" };

export const DOCTRINE_MANIFEST =
  parseContribDoctrineManifest(rawDoctrineManifest);
